module.exports = __webpack_public_path__ + "img/27_78.cea331ae.png";